import moment from 'moment';
import React from 'react';
import {Trans} from 'react-i18next';
import Box from '@mui/material/Box';
import {dateTimeSecFormatMoment} from 'common/formats';

type Props = {
   date: Date | string | number;
   author?: string;
};

const LastUpdatedLabel = React.memo(({date, author}: Props) => {
   const displayDate = moment(+date).format(dateTimeSecFormatMoment);
   return (
      <Box paddingY={1} fontSize=".9rem">
         <Trans>Last updated: {{displayDate}} </Trans>
         {author && <Trans>by {{author}}</Trans>}
      </Box>
   );
});

export default LastUpdatedLabel;
